import { render, staticRenderFns } from "./FooterPartial.vue?vue&type=template&id=80ebdc5a&scoped=true&"
import script from "./FooterPartial.vue?vue&type=script&lang=js&"
export * from "./FooterPartial.vue?vue&type=script&lang=js&"
import style0 from "./FooterPartial.vue?vue&type=style&index=0&id=80ebdc5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ebdc5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFooter,VSpacer})
